import { replaceTokensInString } from '@app/utils';
import { useDispatch, useSelector } from 'react-redux';
import RequestByDate from '../../../RequestByDate';
import { useEffect } from 'react';
import { useTranslation } from 'react-i18next';
import { useFormikContext } from 'formik';
import { getDefaultRequestByDate } from '../../../utils';
import { useWebStorage } from '@app/hooks';
import cx from 'classnames';
import styles from './OrderInformationRequestByDate.module.scss';
import { updateDateAndEquipment } from '@app/store/checkout/actions';
import {
  IS_FULFILLMENT_TYPE_DROPBOX_PASSED,
  IS_FULFILLMENT_TYPE_PICKUP_PASSED,
  IS_FULFILLMENT_TYPE_SHIPTO_PASSED
} from '@app/components/pages/account/shopping-preferences/constants';
import {
  PICKUP,
  DELIVERY,
  SHOP_ONLINE,
  DROPBOX
} from '@app/components/pages/checkout/RequestByDate/constants';

const REQUEST_BY_DATE = 'requestByDate';
const SESSION = 'session';

const OrderInformationRequestByDate = ({ requestByDate }) => {
  const [t] = useTranslation();
  const dispatch = useDispatch();

  const { setFieldValue, setFieldTouched, values, touched } =
    useFormikContext();
  const requestByDateRequired = useSelector(
    state => !!state.orders.requestByDate?.requestByDateEnabled
  );
  const fulfillment = useSelector(
    s => s.orders.byId?.[s.orders.current]?.fullfillment
  );

  const getFulfillmentType = () => {
    if (!fulfillment?.type || fulfillment.type.toLowerCase() === PICKUP) {
      return IS_FULFILLMENT_TYPE_PICKUP_PASSED;
    }
    if (
      fulfillment.type.toLowerCase() === DELIVERY ||
      fulfillment.type.toLowerCase() === SHOP_ONLINE
    ) {
      return IS_FULFILLMENT_TYPE_SHIPTO_PASSED;
    }
    if (fulfillment.type.toLowerCase() === DROPBOX) {
      return IS_FULFILLMENT_TYPE_DROPBOX_PASSED;
    }
  };
  const isPccDisplayRBDByAvailability = useSelector(
    s => s?.featureFlag?.PCCDisplayRBDByAvailability
  );
  const hasValue = !!values[REQUEST_BY_DATE];
  const wasTouched = !!touched[REQUEST_BY_DATE];
  const [, setSavedRequestByDate] = useWebStorage(REQUEST_BY_DATE, SESSION);
  const { format: dateFormat } = requestByDate;

  /**
   * Sets default RBD value if there is none set and when user changes stores without setting value or proceeding to checkout.
   * There is a default RBD on xOrder that we will use to set this.
   */
  useEffect(() => {
    if ((isPccDisplayRBDByAvailability || !hasValue) && !wasTouched) {
      setFieldTouched(REQUEST_BY_DATE, true, false);
      const defaultRequestByDate = getDefaultRequestByDate(requestByDate);
      if (defaultRequestByDate) {
        setFieldValue(REQUEST_BY_DATE, defaultRequestByDate, true);
      }
    }
  }, [
    hasValue,
    isPccDisplayRBDByAvailability,
    requestByDate,
    setFieldTouched,
    setFieldValue,
    wasTouched
  ]);

  /**
   * Sets and validates RBD field when cut off times change caused by the user changing stores.
   */
  useEffect(() => {
    if (wasTouched) {
      const defaultRequestByDate = getDefaultRequestByDate(requestByDate);
      setFieldValue(REQUEST_BY_DATE, defaultRequestByDate, true);
    }
  }, [requestByDate, setFieldValue, wasTouched]);

  /**
   * calling updateDateAndEquipment onChange rather than onBlur
   * onBlur is not fired for the DatePicker if a date is selected via the calendar
   * @param {*} date from date picker
   */
  const handleChange = date => {
    if (date) {
      setFieldTouched(REQUEST_BY_DATE, true);
      dispatch(
        updateDateAndEquipment({
          requestByDate: date,
          equipment: values.equipment
        })
      );
      setSavedRequestByDate(date);
    }
  };

  const helpText = dateFormat
    ? replaceTokensInString(t('PLEASE_ENTER'), dateFormat)
    : '';

  return (
    <div className={styles['request-by-date_container']}>
      <RequestByDate
        className={cx(styles['order-information__request-date--print'], {
          'd-print-none': !values[REQUEST_BY_DATE]
        })}
        fulfillmentType={getFulfillmentType()}
        handleChange={handleChange}
        helpText={helpText}
        helpTextClassname="d-print-none u-color--DarkGray"
        errorClassName="d-print-none"
        requestByDate={requestByDate}
        requestByDateRequired={requestByDateRequired}
      />
    </div>
  );
};

export default OrderInformationRequestByDate;
